import { render, staticRenderFns } from "./FooterGroups.vue?vue&type=template&id=52fae8b4&"
import script from "./FooterGroups.vue?vue&type=script&lang=js&"
export * from "./FooterGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FooterGroup: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Footer/FooterGroup.vue').default,FooterSocials: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Footer/FooterSocials.vue').default})
